import { render, staticRenderFns } from "./trade-walk.vue?vue&type=template&id=2cddf969&scoped=true&"
import script from "./trade-walk.vue?vue&type=script&lang=js&"
export * from "./trade-walk.vue?vue&type=script&lang=js&"
import style0 from "./trade-walk.vue?vue&type=style&index=0&id=2cddf969&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cddf969",
  null
  
)

export default component.exports